export enum RETAIL_INSURANCE_PATHS {
  TRACTOR_INSURANCE = "/tractor-insurance",
  COMMERCIAL_GOODS_VEHICLE = "/commercial-vehicle-goods-carrying-insurance",
  COMMERCIAL_PASSENGER_VEHICLE = "/commercial-vehicle-passenger-carrying-insurance",
  MISCELLANEOUS_VEHICLES = "/motor-insurance-for-miscellaneous-vehicles",
  JEWELRY_SHOWROOMS = "/jewelry-showrooms-insurance",
  SHOPKEEPERS_INSURANCE = "/comprehensive-shopkeepers-insurance",
  HOUSEHOLDER_INSURANCE = "/householder-insurance",
}
